import React, { useState, MouseEvent } from 'react'
import cx from 'classnames'
import { l, Popover } from '@manychat/manyui'

import FilterFieldsSearch from 'common/filter/components/FilterFieldsSearch'
import { useFilterContext } from 'common/filter/components/Filters/FilterContext'
import { ConditionField } from 'common/filter/interfaces'

import cm from './AddCondition.module.css'

interface AddConditionProps {
  className?: string
  label?: string
  first?: boolean
  firstClassName?: string
  groupIndex: number
}

export const AddCondition: React.FC<AddConditionProps> = ({
  className,
  label = `+ ${l.translate('Condition')}`,
  first,
  firstClassName,
  groupIndex,
}) => {
  const filter = useFilterContext()
  const { builderId, fields } = filter
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleRequestClose = () => {
    setAnchorEl(null)
  }

  const handleFieldSelect = (field: ConditionField) => {
    filter.createCondition({ groupIndex, field })
    handleRequestClose()
  }

  const isOpen = Boolean(anchorEl)
  const isFirst = !isOpen && first

  return (
    <a
      data-test-id="add-condition-button"
      data-onboarding-id="add-condition-button"
      className={cx(cm.addConditionBtn, className, {
        [cm.first]: isFirst,
        [firstClassName || '']: isFirst && firstClassName,
      })}
      onClick={handleClick}
    >
      <span>{label}</span>
      <Popover
        open={isOpen}
        anchor={anchorEl}
        anchorOrigin="bottom left"
        popoverOrigin="top left"
        autoPosition="auto"
        onRequestClose={handleRequestClose}
      >
        <FilterFieldsSearch
          onSelect={handleFieldSelect}
          fields={fields}
          isBuilder={Boolean(builderId)}
        />
      </Popover>
    </a>
  )
}
